import { splitArray } from '../../model/utils/array';

import Styles from './styles.module.scss';

export interface RecipientItemModel {
	id: string;
	name: string;
	status: 'accepted' | 'declined' | 'received' | 'sent' | 'not-sent';
}

export interface RecipientGroupModel {
	groupNumber: number;
	recipients: RecipientItemModel[];
}

interface Props {
	items: RecipientGroupModel[];
}

export const RecipientGroupsList = ({ items }: Props) => {
	return (
		<div className={Styles.recipients}>
			{items?.map((group) => (
				<div key={group.groupNumber} className={Styles.detailsRow}>
					<div className={Styles.groupNumber}>Group {group.groupNumber + 1}</div>
					<div className={Styles.group}>
						{splitArray(group.recipients ?? [], 4).map((recipientChunk, index) => (
							<div key={`${group.groupNumber}-${index}`} className={Styles.row}>
								{recipientChunk.map((recipient) => {
									if (!recipient.name) return null;
									return (
										<div
											key={recipient.id}
											className={`${Styles.item} ${Styles[recipient.status]}`}
										>
											<div className={Styles.indicator} />
											{recipient.name}
										</div>
									);
								})}
							</div>
						))}
					</div>
				</div>
			))}
		</div>
	);
};
